import { render, staticRenderFns } from "./RewardsBoxElement.vue?vue&type=template&id=1331ee96&scoped=true"
import script from "./RewardsBoxElement.vue?vue&type=script&lang=js"
export * from "./RewardsBoxElement.vue?vue&type=script&lang=js"
import style0 from "./RewardsBoxElement.vue?vue&type=style&index=0&id=1331ee96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331ee96",
  null
  
)

export default component.exports